/* eslint-disable dot-notation */
/* eslint-disable prefer-destructuring */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import SectionHeader from '../../../components/sectionHeader';
import Clickable from '../../../components/clickable/Clickable';
import styles from '../inspection.module.scss';
import Table from './components/Table';
import icon from '../../../icons/training.png';
import { fetchPortalTrainings, clearState } from '../redux/action';

const TrainingList = (props) => {
  const {
    actionFetchPortalTrainings,
    myTrainings,
    actionClearState
  } = props;

  const [activeTab, setActiveTab] = useState('open');
  const [trainings, setTrainings] = useState([]);

  useEffect(() => {
    actionFetchPortalTrainings();
    actionClearState();
  }, [actionFetchPortalTrainings, actionClearState]);

  const onActiveTab = (data) => {
    if (data === 'open') {
      displayActiveTrainings();
    } else {
      displayClosedTrainings();
    }
    setActiveTab(data);
  };

  const displayActiveTrainings = () => {
    const assigned = myTrainings['assigned'];
    const in_progress = myTrainings['in_progress'];
    const activeTrainings = assigned.concat(in_progress);
    setTrainings(activeTrainings);
  };

  const displayClosedTrainings = () => {
    const completed = myTrainings['completed'];
    setTrainings(completed);
  };

  useEffect(() => {
    if (myTrainings) {
      displayActiveTrainings();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myTrainings]);

  return (
    <>
      <SectionHeader icon={icon} translationID="training.title" defaultTitle="My Trainings">
        <div className={styles.detailHeader}>
          <div className={styles.navigation}>
            <Clickable className={activeTab === 'open' ? styles.active : ''} onClick={() => onActiveTab('open')}>
              <FormattedMessage id="training.active" defaultMessage="Active" />
            </Clickable>
            <Clickable className={activeTab === 'close' ? styles.active : ''} onClick={() => onActiveTab('close')}>
              <FormattedMessage id="training.list.table.status.Completed" defaultMessage="Completed" />
            </Clickable>
          </div>
        </div>
      </SectionHeader>
      <div style={{ display: 'flex' }} className={styles.toolbar}>
        <div className={styles.counter}>
          {activeTab === 'open'
            ?<FormattedMessage id="training.list.open" defaultMessage="All Active Trainings" />
            :<FormattedMessage id="training.list.completed" defaultMessage="All Completed Trainings" />
          }
        </div>
      </div>
      <div className={styles.container}>
        {myTrainings && trainings && (
          <Table info={trainings} activeTab={activeTab} />
        )}
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  myTrainings: state.trainings.myTrainings
});

const mapDispatchToProps = dispatch => ({
  actionFetchPortalTrainings: () => {
    dispatch(fetchPortalTrainings());
  },
  actionClearState: () => {
    dispatch(clearState());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TrainingList));
